const styles = theme => ({
  titleName: {
    fontSize: 21,
    fontWeight: 600,
  },
  dividerView: {
    marginTop: 20,
    marginBottom: 20,
  },
  downloadButton: {
    borderRadius: 4,
    fontWeight: 500,
    fontSize: 14,
  },
  plotButton: {
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 14,
  },
  uploadIcon: {
    height: 16,
    width: 16,
    filter: 'brightness(0) invert(1)',
  },
  uploadButton: {
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 16,
    background: `${theme.palette.primary.adgmBlack} !important`,
    color: `${theme.palette.primary.white} !important`,
    textTransform: 'none',
    width: 256,
  },
  uploadPhotoButton: {
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 16,
    textTransform: 'none',
    color: '#fff',
    width: 223,
    background: theme.palette.primary.adgmBlack,
  },
  headerTitle: {
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      margin: '20px 0px 20px 0px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      '& $titleName': {
        padding: 16,
        fontSize: '16px',
        fontWeight: '600',
        background: '#F8F8F8',
      },
    },
  },
  hideUploadSection: {
    display: 'none !important',
  },
  dragContainer: {
    height: 230,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  dropFileText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#484456',
    marginTop: 16,
  },
  dragFileText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#484456',
    marginTop: 16,
  },
  dragFilesizeText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#484456',
  },
  dragFileTextandSize: {
    fontSize: 14,
    fontWeight: 400,
    color: '#484456',
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  selectPropButton: {
    textAlign: 'center',
    marginTop: 32,
    marginRight: 16,
    marginLeft: 16,
    fontWeight: 600,
  },
  border: {
    borderBottom: '2px solid lightgray',
    width: '100%',
  },
  '@media (max-width:768px)': {
    downloadButtonContainer: {
      padding: 16,
      display: 'flex',
      justifyContent: 'center',
    },
    dividerView: {
      marginTop: 40,
      marginBottom: 40,
    },
    downloadButton: {
      borderRadius: 4,
      fontWeight: 500,
      fontSize: 14,
      width: '100%',
    },
    plotButton: {
      borderRadius: 4,
      fontWeight: 600,
      fontSize: 14,
      width: '100%',
    },
    uploaderContainer: {
      paddingLeft: 16,
      paddingRight: 16,
    },
    uploadButton: {
      borderRadius: 4,
      fontWeight: 600,
      fontSize: 16,
      padding: 10,
      textTransform: 'none',
      background: theme.palette.primary.main,
      //   color: '#fff',
      width: '256px',
    },
    uploadPhotoButton: {
      borderRadius: 4,
      fontWeight: 600,
      fontSize: 16,
      textTransform: 'none',
      background: theme.palette.primary.adgmBlack,
    },
  },
  '@media (min-width:600px) and (max-width:760px)': {
    headingContainer: {
      padding: 16,
    },
  },
});

export default styles;
